import { render, staticRenderFns } from "./AttentionList.vue?vue&type=template&id=34441532&scoped=true&"
import script from "./AttentionList.vue?vue&type=script&lang=js&"
export * from "./AttentionList.vue?vue&type=script&lang=js&"
import style0 from "./AttentionList.vue?vue&type=style&index=0&id=34441532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34441532",
  null
  
)

export default component.exports